import Permissions from "../../supportFunctions/Permissions";
import { LDFlagSet } from "launchdarkly-js-client-sdk";
import UsersService from "@velocity-ehs/user-utils-module";
import {
  INavItem,
  ISolutionsMenuItem,
  addApplicationClassName,
  addApplicationSeparator,
  addSolutionClassNames,
  addSolutionSeparator,
  isDisabledByFeatureFlag,
  isDisabledByPermission,
  isOverrideUnpurchased,
  removeEmptySolutions,
  setCapabilityDestination,
  sortApplications,
} from "./MenuOptionsHelpers";

export const AdminNavItems: INavItem[] = [
  {
    label: "universal_Locations",
    path: "/location",
    permission: [
      Permissions.canManageLocations,
      Permissions.canViewLocationsMenu,
    ],
  },
  {
    label: "universal_persons_users",
    path: "/persons",
    permission: [],
  },
  {
    label: "universal_Configuration",
    path: "/ehs-configurations/Task",
    permission: [Permissions.canViewEhsConfig],
    flag: "showEHSConfigMenu",
  },
  {
    label: "universal_Roles",
    path: "/role",
    permission: [Permissions.canEditRole],
    flag: "enableRoleManagement",
    invertFeatureFlag: true,
  },
  {
    label: "universal_Hierarchies",
    path: "/hierarchies",
    permission: [
      Permissions.canManageOrgHierarchies,
      Permissions.canViewHierarchiesMenu,
    ],
  },
  {
    label: "universal_Customers",
    path: "/customer",
    permission: [Permissions.canViewCustomers],
  },
  {
    label: "universal_Single_Sign_On",
    path: "/singleSignOn",
    permission: [Permissions.canViewSSO],
  },
  {
    label: "universal_Application_Config",
    path: "/applicationConfig",
    permission: [Permissions.canViewAppConfig],
  },
  {
    label: "universal_role_management",
    path: "/role-management/all-roles",
    permission: [Permissions.canViewPolicy, Permissions.canViewRole],
    flag: "enableRoleManagement",
    showIfAnyPermission: true,
  },
  {
    label: "universal_contracting_companies",
    path: "/contracting-companies",
    permission: [Permissions.canViewContractingCompanies],
  },
];

export const getUserSolutions = (
  history: any,
  dispatch: any,
  featureFlags: LDFlagSet
): ISolutionsMenuItem[] => {
  const { assignedSolutions, availableSolutions } = UsersService.user;
  let solutions: ISolutionsMenuItem[] = [
    ...assignedSolutions,
    ...addSolutionClassNames(availableSolutions),
  ];

  solutions.forEach((solution) => {
    solution.items = [];
    solution.command = () => dispatch({ type: "select_solution" });

    solution.applications.forEach((app) => {
      if (isDisabledByFeatureFlag(app, featureFlags)) return;
      if (isDisabledByPermission(app, UsersService.permissions)) return;
      if (isOverrideUnpurchased(app)) return;
      let pendoItemId;
      if (app.assigned === false) {
        pendoItemId = `pendo_${app.applicationCode}`;
      }

      solution.items.push({
        ...app,
        label: app.applicationName,
        className: addApplicationClassName(app),
        id: pendoItemId || app.id,
        command: () =>
          dispatch({
            type: "select_capability",
            goTo: setCapabilityDestination(app, history),
          }),
      });
    });

    sortApplications(solution.items);
    addApplicationSeparator(
      solution,
      UsersService.permissions.canViewUnpurchased
    );
  });

  return addSolutionSeparator(
    removeEmptySolutions(solutions),
    UsersService.permissions.canViewUnpurchased
  );
};
